import { useFormState } from 'react-hook-form';
import { useFormStateIsDirty } from '../useFormStateIsDirty';
import { PreventNavigation } from './PreventNavigation';

export interface IFormPreventNavigationProps {
  /**
   * Elenco di pattern di pathname per cui la navigazione è sempre consentita
   * senza mostrare l'avviso di "modifiche non salvate".
   *
   * Quando l'utente prova a lasciare il form, se il pathname dell'URL di
   * destinazione corrisponde ad almeno una di queste espressioni regolari,
   * la navigazione prosegue senza attivare il prompt di conferma.
   *
   * N.B.: il match viene effettuato solo sul `location.pathname`, non su
   * query string (`search`) o hash (`hash`).
   */
  allowedUrls?: RegExp[];
}

/**
 * Previene la navigazione se il Form RHF è stato modificato, ovvero
 * se ci sono modifiche non salvate.
 *
 * Utilizziamo "isDirty && !isSubmitting" come condizione per evitare di essere
 * bloccati durante il salvataggio di un nuovo form prima del redirect.
 */
export function FormPreventNavigation(props: IFormPreventNavigationProps) {
  const { allowedUrls } = props;
  const { isSubmitting } = useFormState();
  const isDirty = useFormStateIsDirty();

  return (
    <PreventNavigation
      when={isDirty && !isSubmitting}
      allowedUrls={allowedUrls}
    />
  );
}
